const discount = `
    allowedUses
    amount
    discountType
    expire
    id
    products
    productTypes
    text
`;

export default discount;
